import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const IndustrialObjects = (props) => {
  const handleBeneficiaries = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          infrastructure_industrial_objects: Number(value),
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>8.3</span>
          <span className="star">*</span>
        </div>
)}
      titleUA="Об’єкти інфраструктури, промисловість"
      titleEN="Infrastructure, industrial objects"
      children={(
        <div className="flex-group">
          <input
            placeholder="0"
            id="infrastructure_industrial_objects"
            name="infrastructure_industrial_objects"
            className="number"
            value={props.formData.info.landuse_and_beneficiaries.infrastructure_industrial_objects}
            autoComplete="off"
            disabled={props.disabled}
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              const total = props.checkPercent('infrastructure_industrial_objects') + newValue;
              if (total <= 100) {
                handleBeneficiaries(newValue);
              } else {
                e.preventDefault();
              }
            }}
          />
          <span>%</span>
        </div>
)}
    />
  );
};
